import React from 'react';
import ContactList from './components/ContactList';

function App() {
  return (
    <div className="App">
        <ContactList />  
    </div>
  );
}

export default App;
